import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirects legacy `/bookings/:id` and `/bookings/:id/workspace` URLs to the
 * unified `/booking/:bookingId` route. Kept for one release cycle so existing
 * bookmarks and shared links keep working.
 */
export function LegacyBookingRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/booking/${id ?? ''}`} replace />;
}
